import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AutoSuggest from 'react-autosuggest';
import { debounce } from 'lodash';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import { USAutocompleteProApi } from './utils';

const BaseField = ({
  setFieldValue,
  field,
  errorMessage,
  refField,
  addressFieldName = 'address',
  stateFieldName = 'state',
  cityFieldName = 'city',
  zipCodeFieldName = 'zipcode',
  ...props
}) => {
  const [suggestions, setSuggestions] = useState([]);
  const clearSuggestions = () => setSuggestions([]);
  const onSuggestionSelected = (event, { suggestion }) => {
    event.preventDefault();
    setFieldValue(addressFieldName, suggestion?.street_line);
    setFieldValue(stateFieldName, suggestion?.state);
    setFieldValue(cityFieldName, suggestion?.city);
    setFieldValue(zipCodeFieldName, suggestion?.zipcode);
  };

  const onSuggestionsFetchRequested = debounce(({ value }) => {
    USAutocompleteProApi(value)
      .then(uniqSuggestions => {
        setSuggestions(uniqSuggestions);
      })
      .catch(() => {
        setSuggestions([]);
      });
  }, 300);

  const concatenateAddressFields = suggestion => {
    const suggestionLabel = [];
    suggestionLabel.push(suggestion?.street_line);
    suggestionLabel.push(suggestion?.city);
    suggestionLabel.push(suggestion?.state);
    return suggestionLabel.filter(Boolean).join(', ');
  };

  return (
    <AutoSuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={clearSuggestions}
      onSuggestionSelected={onSuggestionSelected}
      focusInputOnSuggestionClick={false}
      shouldRenderSuggestions={value => value && value.trim().length > 2}
      getSuggestionValue={suggestion => suggestion}
      renderSuggestion={suggestion => concatenateAddressFields(suggestion)}
      inputProps={{
        ...field,
        ...props,
        onBlur: e => {
          if (e.name && typeof props.onBlur === 'function') {
            props.onBlur(e);
          }
        },
        autoComplete:
          props.value && props.value.trim().length > 2
            ? 'off'
            : props.autoComplete,
      }}
      renderInputComponent={inputProps => (
        <LabeledTextInput
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...inputProps}
          key={inputProps?.key}
          label={inputProps.placeholder}
          placeholder=""
          errorMessage={errorMessage}
          ref={refField}
        />
      )}
    />
  );
};

BaseField.propTypes = {
  value: PropTypes.string,
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
  }),
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string,
  autoComplete: PropTypes.string,
  setFieldValue: PropTypes.func,
  addressFieldName: PropTypes.string,
  stateFieldName: PropTypes.string,
  cityFieldName: PropTypes.string,
  zipCodeFieldName: PropTypes.string,
  refField: PropTypes.node,
  onBlur: PropTypes.func,
};

export default BaseField;
